module.exports = __webpack_public_path__ + "img/38_61.fefd21d5.png";